import {accessTokenLocalStorageKey, logoutReasonLocalStorageKey} from '../constants';
import storage from './storage';

export const saveSessionLogoutReasonIfNeeded = (token) => {
    const loadedToken = token || storage.load(accessTokenLocalStorageKey);

    if (loadedToken && loadedToken.timestamp && loadedToken.timestamp < Date.now()) {
        localStorage.setItem(logoutReasonLocalStorageKey, 'common.login.errors.session_expired');
    }
};
export const saveUnauthorizedLogoutReasonIfNeeded = () => {
    const token = storage.load(accessTokenLocalStorageKey);

    if (token.id) {
        localStorage.setItem(logoutReasonLocalStorageKey, 'common.login.errors.unauthorized_request');
    } else {
        saveSessionLogoutReasonIfNeeded(token);
    }
};
